
import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <div className="relative min-h-screen bg-[#ede9e3]">
      <div className="absolute inset-0">
        <img
          src="https://static.readdy.ai/image/db812a398b3a5f225f48907587ff778a/0de90e15446e361d12ac2b5d7adaf9e8.png"
          alt="みなとサービス"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60"></div>
        <div className="absolute bottom-0 left-0 right-0 h-1/3 bg-gradient-to-t from-black/70 via-black/40 to-transparent"></div>
      </div>

      <div className="relative z-10 flex flex-col items-center justify-center min-h-screen px-4 md:px-6 pt-24 md:pt-32 pb-12 md:pb-16">
        <div className="max-w-5xl mx-auto text-center text-white w-full">
          <h1 className="text-3xl sm:text-4xl md:text-6xl lg:text-8xl font-bold leading-tight mb-4 md:mb-8">
            長崎県の信頼できる<br />
            軽運送サービス
          </h1>
          <p className="text-base sm:text-lg md:text-2xl lg:text-3xl text-gray-100 mb-8 md:mb-14 leading-relaxed px-2">
            引越しから貨物配送まで、地域密着のきめ細やかなサービス
          </p>
          
          <div className="mb-8 md:mb-12">
            <Link 
              to="/contact"
              className="inline-flex items-center gap-2 md:gap-4 bg-[#ebe960] text-gray-900 px-8 sm:px-10 md:px-14 py-4 sm:py-5 md:py-7 rounded-full text-lg sm:text-xl md:text-3xl lg:text-4xl font-bold hover:bg-[#d4d24e] transition-all hover:scale-105 cursor-pointer whitespace-nowrap shadow-2xl"
            >
              <i className="ri-mail-line text-xl sm:text-2xl md:text-4xl"></i>
              お問い合わせはこちら
            </Link>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-5 mt-10 md:mt-20 max-w-4xl mx-auto">
            <div className="bg-white/10 backdrop-blur-md rounded-xl md:rounded-2xl p-4 sm:p-6 md:p-8 border border-white/20">
              <div className="w-10 h-10 sm:w-12 sm:h-12 md:w-14 md:h-14 bg-[#ebe960] rounded-full flex items-center justify-center mx-auto mb-2 md:mb-4">
                <i className="ri-time-line text-xl sm:text-2xl md:text-3xl text-gray-900"></i>
              </div>
              <p className="text-white font-bold text-xs sm:text-sm md:text-base">24時間対応</p>
            </div>
            <div className="bg-white/10 backdrop-blur-md rounded-xl md:rounded-2xl p-4 sm:p-6 md:p-8 border border-white/20">
              <div className="w-10 h-10 sm:w-12 sm:h-12 md:w-14 md:h-14 bg-[#ebe960] rounded-full flex items-center justify-center mx-auto mb-2 md:mb-4">
                <i className="ri-calendar-check-line text-xl sm:text-2xl md:text-3xl text-gray-900"></i>
              </div>
              <p className="text-white font-bold text-xs sm:text-sm md:text-base">365日対応</p>
            </div>
            <div className="bg-white/10 backdrop-blur-md rounded-xl md:rounded-2xl p-4 sm:p-6 md:p-8 border border-white/20">
              <div className="w-10 h-10 sm:w-12 sm:h-12 md:w-14 md:h-14 bg-[#ebe960] rounded-full flex items-center justify-center mx-auto mb-2 md:mb-4">
                <i className="ri-flashlight-line text-xl sm:text-2xl md:text-3xl text-gray-900"></i>
              </div>
              <p className="text-white font-bold text-xs sm:text-sm md:text-base">即日対応</p>
            </div>
            <div className="bg-white/10 backdrop-blur-md rounded-xl md:rounded-2xl p-4 sm:p-6 md:p-8 border border-white/20">
              <div className="w-10 h-10 sm:w-12 sm:h-12 md:w-14 md:h-14 bg-[#ebe960] rounded-full flex items-center justify-center mx-auto mb-2 md:mb-4">
                <i className="ri-price-tag-3-line text-xl sm:text-2xl md:text-3xl text-gray-900"></i>
              </div>
              <p className="text-white font-bold text-xs sm:text-sm md:text-base">地域最安値</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
